import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  add(event) {
    event.preventDefault()

    const container = this.element.querySelector("#expenses")
    const template = document.querySelector("#expense-template")

    const html = template.innerHTML.replace(/NEW_RECORD/g, Date.now())
    container.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()

    if (!window.confirm("Diese Ausgabe wirklich löschen?")) return

    const wrapper = event.currentTarget.closest("[data-expense-row]")
    if (!wrapper) return

    const isNew = wrapper.dataset.newRecord === "true"

    if (isNew) {
      wrapper.remove()
      return
    }

    // persisted record: mark for destroy
    const destroyInput = wrapper.querySelector("input[data-destroy-field='true'], input[name*='[_destroy]']")
    if (!destroyInput) return
    destroyInput.value = "1"

    // hide and disable row while keeping _destroy submitted
    wrapper.classList.add("hidden")
    wrapper.querySelectorAll("input, select, textarea, button").forEach((el) => {
      if (el !== destroyInput) el.disabled = true
    })
  }
}
